<template>
<div>
  <!-- <h1 v-html="scContent.FieldValues.Parameters['jersey_img']"> </h1> -->
  <!-- <img :src="scContent.FieldValues.Parameters['circle-background']" /> -->
<!-- <div class="theam-layout"> 
     <div class="theam-layout-event-content">
       <div class="theam-layout-event-content__old">
         <span class="theam-layout-event-content__old-value"><strike> {{ event.Event.Market.Option[priceboostSelection]['@odds'] }} </strike> </span>        
       </div>
          <div class="theam-layout-event-content__new">
          <span class="theam-layout-event-content__new-value">{{ scContent.FieldValues.Parameters['copy_now-odds'] }}</span>            
       </div>
     </div>
        <div class="theam-layout-images" v-if="jersey == scContent.FieldValues.Parameters['jersey_img']">
     <div class="theam-layout-images-block" >
        <img class="theam-layout-images-block-one" style="height: 162px" :src="teamShirts.home" alt=""  @error.once="handleImageError">
        <img class="theam-layout-images-block-two" :src="teamShirts.away" alt=""  @error.once="handleImageError">
     </div>
   </div>
</div> -->
<div class="theam-layout"> 
  <div class="theam-layout-event-content" >
  <div class="theam-layout-event-content__old">
         <span class="theam-layout-event-content__old-value"><strike> {{ event.Event.Market.Option[priceboostSelection]['@odds'] }} </strike> </span>        
       </div>
           <div class="theam-layout-event-content__new">
          <span class="theam-layout-event-content__new-value">{{ scContent.FieldValues.Parameters['copy_now-odds'] }}</span>            
       </div>
  </div>
</div> 
	<div class="theam-content">
    <div>
	<div class="promo-header">
	     <header v-html="scContent.FieldValues.Parameters['title'] ">   </header>
       <!-- <img :src="scContent.FieldValues.Parameters['price_boost_logo']" /> -->
</div>
		 <div>
		 <span class="sub-header" v-html="scContent.FieldValues.Parameters['copy_claim']" > </span>     
		 </div>
            <div class="promo-match">
           <p style="color: white;">  {{ eventDate }} {{ event.Event['@name'] }} </p>
        </div>	
		 <div class="btn-now">
       
		         <a class="button button--primary button-bn" style="text-transform: capitalize;font-weight: 900;" :href="scContent.FieldValues.Parameters['reg_link']" v-html="scContent.FieldValues.Parameters['copy_cta']"></a>
  			 </div>

	</div>
        	</div>
</div>
</template>
<script>
export default {
  jersey: "true",
  props: [
    "betSlipUrl",
    "teamShirts",
    "event",
    "eventDate",
    "scContent",
    "priceboostSelection",
    "loggedin"
  ],
  methods: {
    handleImageError(e) {
      e.target.src = this.teamShirts.fallback;
    }
  }
};
</script>
<style lang="scss">
</style>
